module.exports = __webpack_public_path__ + "img/alabama-ag.fee7a359.jpg";